import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { devices } from 'shared/css/devices';

import ExternalLinkIcon from 'assets/icons/arrow-external-link';

export const NavTitleStyled = styled.div`
  ${({ theme: { spacing, colors = {}, typography }, $active, $topMenu }) => `
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    text-decoration: none;
    padding-left: ${$topMenu ? spacing?.(1) : spacing?.(2)};
    padding-right: ${$topMenu ? spacing?.(1) : spacing?.(2)};
    color: ${$active ? colors.grey?.darkest : colors.primary?.default};
    ${$topMenu ? `${typography?.(16)}` : ``}
    ${$topMenu ? 'font-weight: normal;' : ''}
    ${
      $active && !$topMenu
        ? `box-shadow: inset 2px 0px 0px ${colors.primary?.default}; `
        : ''
    }
  `}
`;

export const ArrowExternalLinkStyled = styled(ExternalLinkIcon)`
  margin-left: 4px;
`;

export const NavLinkWrapper = styled(NavLink)`
  ${({ theme: { spacing, colors = {} }, $topMenu, $active }) => `
  padding: ${spacing?.(1)};
  border: 1px solid transparent;
  text-decoration: none;
  :hover {
      background-color: ${colors.outline?.lighter};
    }
    :focus {
      border: 1px dashed ${colors.primary?.default};
    }
    &:active {
      background-color: ${colors.primary?.lightest};
      border: 1px solid ${colors.primary?.default};
    };
  ${
    $topMenu
      ? `
        height: 100%;
        ${
          $active
            ? `box-shadow: inset 0px -3px 0px ${colors.primary?.default}; `
            : ''
        }`
      : `padding-left: ${spacing?.(1)};
         padding-top: ${spacing?.(1)};
         padding-bottom: ${spacing?.(1)};
        `
  }
  `};
`;

export const MobileNavStyled = styled(NavLink)`
  ${({ theme: { spacing, colors = {}, typography }, $active, $topMenu }) => `
    display: flex;
    height: 100%;
    align-items: center;
    text-decoration: none;
    padding-left: ${$topMenu ? spacing?.(1) : spacing?.(2)};
    padding-right: ${$topMenu ? spacing?.(1) : spacing?.(2)};
    padding-top: ${!$topMenu ? spacing?.(1) : 0}};
    padding-bottom: ${!$topMenu ? spacing?.(1) : 0};
    color: ${$active ? colors.primary?.default : colors.grey?.darkest};
    ${$topMenu ? `${typography?.(16)}` : ``}
    ${$topMenu ? 'font-weight: bold;' : ''}

    --shadowX: ${$topMenu ? '0px' : '4px'};
    --shadowY: ${$topMenu ? '-3px' : '0px'};
    ${
      $active
        ? `box-shadow: inset var(--shadowX) var(--shadowY) 0px ${colors.primary?.default}; `
        : ''
    }

    :focus {
      border: 1px dashed ${colors.primary?.default};
    }
    :hover {
      background-color: ${colors.outline?.lighter};
    }
    &:active {
      background-color: ${colors.primary?.lightest};
      border: 1px solid ${colors.primary?.default};
    }

    @media ${devices.laptop} {
      margin-right: ${spacing?.(1)};
    }
  `}
`;
